import { request, instance } from 'hxhy-axios'
import { getStore } from '@/util/store'

instance.interceptors.request.use(
  (config) => {
    const token = getStore({ name: 'access_token' }) || 'e32d6952-2221-4098-b64b-e6187bcb8d5f'
    if (token && !config.noAuth) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    //对请求错误做点什么
    return Promise.reject(error)
  },
)

export default request
